import React from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { saveRegistrationInfo } from "../../../Redux/Redux-slices/saveSaleInfo";
import { useNotification } from "../../../contextApi/NotificationProvider";
import { useNavigate } from "react-router-dom";

function SalesData({closeModalSale}) {
    const dispatch=useDispatch()
    const navigate=useNavigate();

    const { loading, success, error } = useSelector((state) => state.saleData)
      const { showNotification } = useNotification();
    const {
        register,
        handleSubmit,
        formState: { errors },
        trigger,
        reset
      } = useForm()

      const onSubmit = async (data) => {
        const payload = {
          first_name: data.firstName,
          last_name: data.lastName,
          email: data.email,
          company_name: data.company,
          mobile_number: data.mobile,
        };

        try {
          const res = await dispatch(saveRegistrationInfo(payload)).unwrap();

          if (res?.success === true) {
            // showNotification(
            //   "Thanks for joining! You're officially on the waiting list",
            //   "success",
            //   8000
            // );
            navigate("/thank-you")
            reset();
            closeModalSale();
          } else {
            // Custom message if the backend returns success: false
            showNotification("This request has already been received", "error", 8000);
          }
        } catch (error) {
          console.error("Submission Error:", error);

          // Handle unexpected errors only
          const rawMessage =
            error?.message || error?.detail || "Something went wrong";

          const message = rawMessage.includes(":")
            ? rawMessage.split(":")[1].trim()
            : rawMessage;

          showNotification(message, "error", 8000);
        }
      };




  return (
    <div>
      <div className="flex items-center justify-center">
        <div className="bg-white p-8 rounded-2xl w-full max-w-2xl">
          <h4 className="text-xl font-bold text-center mb-4 bg-clip-text text-black">
            Please Enter Your Details

          </h4>

          <p className="text-sm text-gray-700 mb-6 text-center md:font-semibold">Share your info now, and you’ll be at the top of our call list the moment we go live.</p>

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="grid grid-cols-2 gap-4 mb-4">
              <div>
                <label className="text-sm text-gray-700 font-bold">
                  First name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder="John"
                  {...register("firstName")}
                  className="w-full mt-1 p-2 border rounded-md"
                  onBlur={() => trigger("firstName")}
                />
                {errors.firstName && (
                  <p className="text-red-500 text-xs">
                    {errors.firstName.message}
                  </p>
                )}
              </div>
              <div>
                <label className="text-sm text-gray-700 font-bold">
                  Last name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Doe"
                  {...register("lastName")}
                  className="w-full mt-1 p-2 border rounded-md"
                  onBlur={() => trigger("lastName")}
                />
                {errors.lastName && (
                  <p className="text-red-500 text-xs">
                    {errors.lastName.message}
                  </p>
                )}
              </div>
            </div>

            <div className="mb-4">
              <label className="text-sm text-gray-700 font-bold">
                Email address <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                placeholder="you@example.com"
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: "Please enter a valid email address",
                  },
                })}
                className="w-full mt-1 p-2 border rounded-md"
                onBlur={() => trigger("email")}
              />
              {errors.email && (
                <p className="text-red-500 text-xs">{errors.email.message}</p>
              )}
            </div>

            <div className="mb-4">
              <label className="text-sm text-gray-700 font-bold">
                Company name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder="Your Company"
                {...register("company")}
                className="w-full mt-1 p-2 border rounded-md"
              />
            </div>

            <div className="mb-6">
              <label className="text-sm text-gray-700 font-bold">
                Mobile number
              </label>
              <input
                type="number"
                placeholder="+1 123 456 7890"
                {...register("mobile")}
                className="w-full mt-1 p-2 border rounded-md appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                style={{ MozAppearance: "textfield" }} // for Firefox
                maxLength={15}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-2 bg-gradient-to-r from-purple-600 to-blue-500 text-white font-semibold rounded-md hover:opacity-90"
            >
             {loading ? 'Submitting...' : 'Submit'}
            </button>
          </form>

          <div className="border-t border-black mt-4">
            <p className="text-sm text-gray-600 mt-2">
              Note: Your information is used only for internal purposes and is
              never shared with third parties.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SalesData;
